export default "__VITE_ASSET__BALb633L__"